import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import { ContentCard } from '../ContentCard';
import { useContentCarousel } from '../../../../hooks/useContentCaroousel';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from './ContentCarousel.module.scss';

export const ContentCarousel: React.FC = () => {
  const { slidesToRender, visibleContent, slidesCount, isCarousel } = useContentCarousel();
  if (!slidesCount) return null;
  if (!isCarousel) {
    return (
      <section className={styles.carouselContainer}>
        <div className={styles.swiperSlide}>
          <ContentCard content={visibleContent[0]} />
        </div>
      </section>
    );
  }

  return (
    <section className={styles.carouselContainer}>
      <Swiper
        modules={[Pagination, Autoplay]}
        slidesPerView={'auto'}
        spaceBetween={16}
        centeredSlides={true}
        loop={true}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        className={styles.mySwiper}
      >
        {slidesToRender.map((content, index) => (
          <SwiperSlide key={`${content.id}-${index}`} className={styles.swiperSlide}>
            <ContentCard content={content} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};
